import { render, staticRenderFns } from "./TableDeployPackage.vue?vue&type=template&id=a90ff048"
import script from "./TableDeployPackage.vue?vue&type=script&lang=ts"
export * from "./TableDeployPackage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports